// src/data/servicesData.ts
// Or src/data/servicesData.js if you're not using TypeScript

interface ServiceSection {
  id: string;
  title: string;
  content: string[];
}

export const softwareDevelopmentServices: ServiceSection[] = [
  {
    id: "web-development",
    title: "Web Development",
    content: [
      "From developing a simple single static page to complex sophisticated web applications, E-businesses, and social network services, we do it all. More specifically, the services include Client Liaison, Web Design, Web Development, Server Configuration, and creating Integrated and Interactive Web-based Responsive Application.",
    ],
  },
  {
    id: "mobile-app-development",
    title: "Mobile App Development",
    content: [
      "We build mobile applications for iOS and Android devices considering a long array of screen sizes, hardware specifications, configurations, platforms, and audiences for efficient performance and a user-friendly experience. Our services include consulting, designing, development, integration, quality analysis, and testing, maintenance and support, and also modernization.",
    ],
  },
  {
    id: "ui-ux",
    title: "UI and UX",
    content: [
      "We design and develop innovative digital user experiences that solve your complex business problems and provide an organic, unified user experience through our custom UI/UX development services. Our versatile desktop and mobile UI/UX development services leverage the full strength to provide computing power, enhanced graphics, robust security standards, and greater performance.",
    ],
  },
  {
    id: "creative-support",
    title: "Creative Support",
    content: [
      "Supporting your business promotion with an endless range of designs, graphics, arts, illustrations, advertisements, etc. For fulfilling your needs, we search, visualize, consult, brainstorm, explore, compose, review and then disseminate by using creative support tools like word processors, computer-aided design software, generative design software, and computational engines.",
    ],
  },
  {
    id: "cloud",
    title: "Cloud",
    content: [
      "We deliver different services through the internet, which include tools and applications like data storage, servers, databases, networking, and software. Configuration management, continuous integration, automated testing, infrastructure as code, continuous delivery, continuous deployment, and continuous monitoring, all being integral parts of the DevOps methodology that we follow and offer.",
    ],
  },
];

export const digitalMarketingServices: ServiceSection[] = [
  {
    id: "strategy-consulting",
    title: "Strategy & Consulting",
    content: [
      "We collaborate to work on different business functions like Production, Operation, Sales & Marketing, Research & Development, etc. We adopt cutting-edge processes and proprietary technologies so that our partners can have a competitive edge in their business arena.",
      "We enumerate your business measures and risk factors and build a holistic understanding of the parameters that impact growth and define solutions for realizing and hence tapping the best of opportunities.",
    ],
  },
  {
    id: "earned-owned-media",
    title: "Earned & Owned Media",
    content: [
      "Brand positioning should be dynamic and fluid to place your brands in the minds of the majority of the population.",
      "We create authentic, engaging experiences that earn reach and build everlasting relationships between brands and their customers through mediums like blog posts and content like posts, photos, videos, campaigns etc. through social media and other channels.",
    ],
  },
  {
    id: "seo",
    title: "Search Engine Optimization (SEO)",
    content: [
      "We support clients in having insights into the impediments to the website’s search engine performance. We audit the competitive landscape and cover every intricacy of technical implementation. We also ascertain that overall content and site experiences are pertinent, valuable, effortlessly accessible, and reach as many end-users.",
    ],
  },
  {
    id: "organic-social-media-marketing",
    title: "Organic Social Media Marketing",
    content: [
      "Making an impact in society begins with listening and understanding audience behaviors, and generating meaningful content experiences that can lead to enduring brand and consumer relationships",
      "Our solutions consist of social content planning, social channel management, resourceful storytelling, social listening and content analysis, and analytics for decision making.",
    ],
  },
  {
    id: "content-marketing",
    title: "Content Marketing",
    content: [
      "We work with you to understand your company’s goals, your target audience, and exactly what it is that distinguishes you in your realm.",
      "We help you in determining the timing of the content creation, quantity to be produced, where to be promoted, and how your audience will engage with it. This process, anchored in our proven frameworks, delivers continuous innovation and long-term value.",
    ],
  },
  {
    id: "creative-management",
    title: "Creative Management",
    content: [
      "In the present age, creatives play a vital role in a brand's design architecture on the website, social media, digital ads, videos, etc. We feel that innovative ideas and effective creativity are critical components of an integrated marketing strategy.",
      "We create impactful creative assets that reflect our clients’ brands, connect with their audiences, and ultimately drive performance.",
    ],
  },
  {
    id: "paid-media",
    title: "Paid Media",
    content: [
      "We ensure relevant and consistent interactions across channels, with both new and prospective customers through online advertising (like social media ads, Pay Per click, and display ads).",
      "This is the fast, effective way to position your brands in front of high-converting customers and thus, ultimately reach your desired target audience.",
    ],
  },
  {
    id: "ppc",
    title: "PPC: Pay Per Click",
    content: [
      "We connect your brand with the right audience at the right moment. We incorporate our deep expertise, bespoke strategies, approaches, and even tools to maximize campaign performance and drive business growth for our clients.",
    ],
  },
  {
    id: "email-marketing",
    title: "Email Marketing",
    content: [
      "Marketing automation software allows you to learn from prospects, customers, online behaviour in real-time via tracking, measuring and nurturing of prospects and sales/leads with relevant and timely content or through campaigns – all automatically and at scale. Ready to review your marketing plans to take your business to the next level?",
    ],
  },
];
